export default __webpack_public_path__ + "static/media/2382.b0366e36.png";